/**
 * Report ports: the client's own report pages rebuilt as React components
 * (AJ 2026-09-28: "use the html that is already built to build the react
 * components"). A template tab names one with `report: <id>`; index.tsx maps
 * the id to its component. This list is plain JS so scripts/report-registry
 * .test.mjs can check the templates against it without a TSX loader.
 *
 * An id listed here MUST have a case in index.tsx. An id used by a template
 * but absent here is allowed: the tab keeps the section grid until the port
 * lands.
 */
export const REPORT_IDS = Object.freeze([
  "ar_aging",
  "containers",
  "disposal",
  "dot_audit",
  "incidents",
  "price_increase",
  "revenue",
  "ro_efficiency",
  "route_profitability",
  "sl_cart",
]);

export function isReportId(id) {
  return typeof id === "string" && REPORT_IDS.includes(id);
}
